import http from '../api/http'

export default class LinksApi {
  static getLinks() {
    return http.get(`/api/openLinks`)
  }
}
